<h1 class="sign-in-text">Sign in</h1>
<p class="sign-in-subtext">
    Please fill the Password for number <span>{{ mobileNumber }}</span>
</p>
<form name="signinForm" [formGroup]="signinForm" (submit)="signIn()">
    <mat-form-field>
        <mat-label>Password</mat-label>
        <input matInput data-test="password-input" formControlName="password" type="password"
            required />
        @if (signinForm.get('password').hasError('minlength') || signinForm.get('password').hasError('required')) {
            <mat-error>
                Password entered is incorrect.
            </mat-error>
        }
    </mat-form-field>
    <input type="submit" style="position: absolute; left: -9999px" />
</form>

<p class="forgot-password" (click)="initiateResetPassword()">Forgot Password?</p>
<p class="login-with" (click)="generateOtp('otp')">Login with OTP</p>

<div class="btn-wrapper">
    <button btn-primary size="full" (click)="signIn()" [isLoading]="btnLoading">Submit</button>
</div>